const STEP_LABELS = {
  brands: "a brand",
  categories: "categories",
  attributes: "attributes",
};

function stepIsDone(step, { state, preview, detected }) {
  if (!step) return false;
  if (state.ack?.[step.id]) return true;
  if (preview) return false;
  if (step.soft) return false;
  return !!detected[step.id];
}

function formatList(ids) {
  const labels = ids.map((id) => STEP_LABELS[id] || id);
  if (labels.length === 0) return "";
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(", ")}, and ${labels[labels.length - 1]}`;
}

/**
 * Hint shown while the merchant has no products yet - lists catalog prerequisites,
 * with attributes only required when selling variants.
 */
export function getProductSetupHint({ state, preview, detected, sellsVariants, steps }) {
  if (!preview && detected.products) return null;

  const byId = (id) => steps.find((s) => s.id === id);
  const productsStep = byId("products");
  if (stepIsDone(productsStep, { state, preview, detected })) return null;

  const brandsStep = byId("brands");
  const categoriesStep = byId("categories");
  const attributesStep = byId("attributes");

  const missing = [];
  if (!stepIsDone(brandsStep, { state, preview, detected })) missing.push("brands");
  if (!stepIsDone(categoriesStep, { state, preview, detected })) missing.push("categories");
  if (sellsVariants && !stepIsDone(attributesStep, { state, preview, detected })) {
    missing.push("attributes");
  }

  if (missing.length === 0) {
    const readyParts = ["brand", "categories"];
    if (sellsVariants) readyParts.push("attributes");
    return {
      tone: "ready",
      text:
        readyParts.length === 3
          ? "Your brand, categories, and attributes are in place - you're ready to add your first product."
          : "Your brand and categories are in place - you're ready to add your first product.",
    };
  }

  const list = formatList(missing);
  if (sellsVariants) {
    return {
      tone: "pending",
      text: `Before adding products, set up ${list} first. Attributes are needed for sizes or colours.`,
      missing,
    };
  }

  return {
    tone: "pending",
    text: `Before adding products, set up ${list} first. Attributes are optional unless you sell variants - use the toggle above if you need them.`,
    missing,
  };
}
